const HOME_TYPE_KEYS = {
  'Apartment': 'quiz.homeTypes.apartment',
  'Terraced': 'quiz.homeTypes.terraced',
  'Terraced House': 'quiz.homeTypes.terraced',
  'Semi-detached': 'quiz.homeTypes.semiDetached',
  'Semi-Detached House': 'quiz.homeTypes.semiDetached',
  'Detached': 'quiz.homeTypes.detached',
  'Detached House': 'quiz.homeTypes.detached',
  'Corner house': 'quiz.homeTypes.corner',
  'Bungalow': 'quiz.homeTypes.bungalow',
  'Monument / Protected': 'quiz.homeTypes.monument',
  'Monument': 'quiz.homeTypes.monument',
  'Farmhouse': 'quiz.homeTypes.farmhouse',
};

const BUILD_PERIOD_KEYS = {
  'Before 1975': 'quiz.buildPeriods.before1975',
  'After 2015': 'quiz.buildPeriods.after2015',
};

const COUNTRY_NAMES = {
  NL: { en: 'Netherlands', nl: 'Nederland', de: 'Niederlande', fr: 'Pays-Bas' },
  BE: { en: 'Belgium', nl: 'België', de: 'Belgien', fr: 'Belgique' },
  DE: { en: 'Germany', nl: 'Duitsland', de: 'Deutschland', fr: 'Allemagne' },
  FR: { en: 'France', nl: 'Frankrijk', de: 'Frankreich', fr: 'France' },
};

export function translateHomeType(value, t) {
  const key = HOME_TYPE_KEYS[value];
  return key ? t(key) : value;
}

export function translateBuildPeriod(value, t) {
  const key = BUILD_PERIOD_KEYS[value];
  return key ? t(key) : value;
}

export function translateCountry(code, lang) {
  const names = COUNTRY_NAMES[code];
  if (!names) return code;
  return names[lang] || names.en || code;
}
